module.exports = __webpack_public_path__ + "static/media/cf-logo.8f43b374.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/agent-info-verification/images/cf-logo.svg
// module id = 527
// module chunks = 0